import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import ProductTableRow from 'domains/product/organisms/table/product-table-row'
import { Table } from 'reactstrap'
import PaginationBar from 'components/organisms/pagination-bar/'

const proptypes = {
  tableProps        : PropTypes.object,
  products          : PropTypes.array,
  pagination        : PropTypes.object,
  isLoading         : PropTypes.bool,
  onClickPageDetail : PropTypes.func,
  onPageChange      : PropTypes.func
}

const defaultProps = {
  tableProps        : {},
  products          : [],
  pagination        : {},
  isLoading         : true,
  onClickPageDetail : () => {},
  onPageChange      : () => { }
}

const ProductTable = ({
  tableProps,
  products,
  pagination,
  isLoading,
  onClickPageDetail,
  onPageChange
}) => {
  const totalColumns = 13
  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th scope="col">{ 'picture' }</th>
          <th scope="col">{ 'name' }</th>
          <th scope="col">{ 'detail' }</th>
          <th scope="col">{ 'gender' }</th>
          <th scope="col">{ 'price' }</th>
          <th scope="col">{ 'productable type' }</th>
          <th scope="col">{ 'live date' }</th>
          <th scope="col">{ 'age' }</th>
          <th scope="col">{ 'status' }</th>
          <th scope="col">{ 'stock' }</th>
          <th scope="col">{ 'action' }</th>
        </tr>
      </thead>
      <tbody>
        {
          products.map((product) => (
            <ProductTableRow
              key={ `ProductTableRow-${product.id}` }
              handleClick={ () => onClickPageDetail(product.id) }
              product={ product }
            />
          ))
        }

        {
          products.length === 0 &&
          <tr>
            <td
              colSpan={ totalColumns }
              className='bg-warning text-white'
            >
              <i className='fas fa-info-circle mr-3' />
              { 'No Product found based on your filters.' }
            </td>
          </tr>
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <PaginationBar
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )

}

ProductTable.propTypes    = proptypes
ProductTable.defaultProps = defaultProps

export default ProductTable
